import BaseAPI, { querySuffix } from "./BaseAPI";

export default class SensorAPI extends BaseAPI {
    constructor(emitter) {
        super(emitter, "sensors", "sensor");
    }
    async ListPage({ limit = 100, page_token = "" } = {}) {
        const page = await this._request(
            "get",
            this._url(querySuffix({ limit, page_token })),
            null,
            { rawData: true }
        );
        return { data: page.data || [], next_page_token: page.next_page_token || "" };
    }
    async List() {
        const sensors = [];
        let token = "";
        do {
            const page = await this.ListPage({ page_token: token });
            sensors.push(...page.data);
            token = page.next_page_token;
        } while (token);
        return sensors;
    }
    async Rename(eui, label) {
        return this._request("put", this._url(`/${encodeURIComponent(eui)}`), { label });
    }
}
